import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { isUndefined } from 'underscore';

import { replaceFragment } from 'location-helper';
import { event_path as eventPath } from 'routes-helper';

const { isFootball } = window.Sport;
const { EventsPresenter, EventsIndexView } = window;

export default () => {
  const { sportId, meetingId, marketTypeId } = useParams();

  useEffect(() => {
    const eventsPresenter = new EventsPresenter(sportId, meetingId, marketTypeId);
    const defaultPresentation = () => { new EventsIndexView(eventsPresenter).render(); };

    if (!isUndefined(marketTypeId) || isFootball(sportId)) {
      defaultPresentation();
      return;
    }

    // If no market type id and no football, first we fetch the events
    // In order to navigate to the event level if only 1 event
    eventsPresenter.fetch({
      success: () => {
        eventsPresenter.setFetched();
        const events = eventsPresenter.eventsCollection();

        if (events.size() === 1) {
          replaceFragment(eventPath(events.first().attributes));
        } else {
          defaultPresentation();
        }
      },
      error: defaultPresentation,
    });
  }, [sportId, meetingId, marketTypeId]);

  return null;
};
